export default {
  getProductSpecSheetImage: (state) => state.productSpecSheetImage,
};
